module.exports = __webpack_public_path__ + "static/img/6.4b3faeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6.png
// module id = RcmW
// module chunks = 0